export default "/adoption/@prefecture";
